export default __webpack_public_path__ + "static/media/exceller-tour.e00ab638.png";